import * as React from "react";
import ArrowIcon from "./DownArrowIcon";

export default function RightArrowIcon(
  props: React.ComponentPropsWithoutRef<typeof ArrowIcon>
): React.ReactElement {
  return <ArrowIcon css={{ transform: "rotate(-90deg)" }} {...props} />;
}
